angular.module("datiRichiesta.components", []).component("datiRichiesta", {
    templateUrl: "ng/components/richiestaCessione/datiRichiesta/datiRichiesta.view.html",
    bindings: {
        isRichiestaPv: "<",
        isRichiestaVoltura: "<",
        model: "=",
        exportValidity: "&",
        readOnly: "="
    },
    controllerAs: "datiRichiestaCtrl",
    controller: function DatiRichiesta(
        $typeDomainService,
        MotivoVoltura
    ) {
        var self = this;

        self.$onInit = function () {
            self.supportModel = {
                domainList: [],
                descrizioneProgetto: self.model.metadata.cessioneVoltura.motivoVoltura,
                selectDeselectAll: {
                    selected: false
                }
            }

            self.appContract = {
                numeroContratto: null,
                modulo: null,
                cdBeni: []
            }

            if (self.isRichiestaPv) {
                self.getDomainSet();
            }
            checkMotivoLength();
            self.verifyDatiRichiesta();
        }

        self.onCheckboxChange = function (el) {
            el.selected = !el.selected;
            self.model.metadata.cessioneVoltura.contratti.forEach(function (contratto) {
                if (el.numero === contratto.numero && el.modulo === contratto.modulo) {
                    contratto.selected = el.selected;
                }
            })
        }

        self.selectedDeselectedAll = function (element) {
            element.selected = !element.selected;
            self.model.metadata.cessioneVoltura.contratti.forEach(function (contratto) {
                contratto.selected = element.selected;
            })
        }

        self.getDomainSet = function () {
            $typeDomainService.getDomainSet("RI_POSTVENDITA", "VOLTURA_MO").then(function (response) {
                self.supportModel.domainList = response.domainList;
                if (self.model.metadata.cessioneVoltura.motivoVoltura) {
                    self.supportModel.descrizioneProgetto = self.supportModel.domainList.
                    find(function (element) {
                        return element.description === self.model.metadata.cessioneVoltura.motivoVoltura.id
                    });
                }
            });
        }

        self.handleChange = function (property, value) {
            switch (property) {
                case 'motivazioneVoltura':
                    if (value) {
                        self.model.metadata.cessioneVoltura.motivoVoltura.id = value.description;
                        self.model.metadata.cessioneVoltura.motivoVoltura.description = value.name;
                    } else {
                        self.model.metadata.cessioneVoltura.motivoVoltura = MotivoVoltura.build();
                    }
                    break;
                case "motivoCessione":
                    self.model.metadata.cessioneVoltura[property] = value;
                    checkMotivoLength();
                case 'piva':
                case 'ragioneSociale':
                case 'emailPec':
                case 'cf':
                    self.model.metadata.cessioneVoltura.destinatario[property] = value;
                    break;
                case 'dataStipulaAtto':
                    self.model.metadata.cessioneVoltura.motivoVoltura.dataStipulaAtto = value;
                    break;
                default:
                    break;
            }
            self.verifyDatiRichiesta();
        }

        self.verifyDatiRichiesta = function () {
            var datiRichiesta = false;
            var motivoVoltura = false;
            var motivoCessione = false;

            motivoVoltura = self.isRichiestaPv && self.isRichiestaVoltura ? self.model.metadata.cessioneVoltura.motivoVoltura : true;
            motivoCessione = self.isRichiestaPv && !self.isRichiestaVoltura ? self.model.metadata.cessioneVoltura.motivoCessione : true;

            if (self.isRichiestaVoltura) {
                datiRichiesta =
                    self.model.metadata.cessioneVoltura.destinatario.piva &&
                    self.model.metadata.cessioneVoltura.destinatario
                        .ragioneSociale &&
                    self.model.metadata.cessioneVoltura.destinatario.cf &&
                    self.model.metadata.cessioneVoltura.destinatario.emailPec &&
                    self.model.metadata.cessioneVoltura.motivoVoltura
                        .dataStipulaAtto;
            } else {
                datiRichiesta =
                    self.model.metadata.cessioneVoltura.destinatario.piva &&
                    self.model.metadata.cessioneVoltura.destinatario
                        .ragioneSociale &&
                    self.model.metadata.cessioneVoltura.destinatario.cf &&
                    self.model.metadata.cessioneVoltura.destinatario.emailPec;
            }

            if (datiRichiesta && motivoVoltura && motivoCessione) {
                self.exportValidity({
                    validity: true
                });
            } else {
                self.exportValidity({
                    validity: false
                });
            }

        }

        var checkMotivoLength = function () {
            if (!self.model.metadata.cessioneVoltura.motivoCessione ||
                self.model.metadata.cessioneVoltura.motivoCessione.length < 20) {
                self.motivoNonValido = true;
            } else {
                self.motivoNonValido = false;
            }
        }
    }
})